/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import QrCode from 'DesignSystem/QrCode/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Qr/Content"
  
}) {
let treatmentPlanRequestUrlValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_request',
path: 'url',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<QrCode
  viewPath={`${viewPath}/QrCode`}
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 data="treatment_plan_request.url"
 value={treatmentPlanRequestUrlValueData}
 size={200}
/>
</div>
{children}
</React.Fragment>)
}